// extracted by mini-css-extract-plugin
export var linkText = "_po-0";